import { ASSETS_GROUPS } from '@/entities/account';
import type { AssetsPriceAsset } from '@/shared/types';

export type MarketAsset = {
  code: string;
  name: string;
  icon?: string;
  price: number;
  precision: number;
  deltaPercent: number | null;
};

const FIAT_DELTA_PERCENT = 0;

const getDeltaPercent = (asset: AssetsPriceAsset): number | null => {
  if (asset.percentChange24h != null) {
    return asset.percentChange24h;
  }

  return asset.group === ASSETS_GROUPS.fiat ? FIAT_DELTA_PERCENT : null;
};

const toMarketAsset = (
  asset: AssetsPriceAsset,
  basePrecission: number,
  icons: Record<string, string> | undefined
): MarketAsset => ({
  code: asset.code,
  name: asset.name,
  icon: icons?.[asset.code],
  price: asset.baseRate,
  precision: basePrecission,
  deltaPercent: getDeltaPercent(asset),
});

export { toMarketAsset };
